export const AUTH_LOGIN_REQUEST = "@auth.login.request";
export const AUTH_LOGIN_SUCCESS = "@auth.login.success";
export const AUTH_LOGIN_LOADING = "@auth.login.loading";
export const AUTH_LOGIN_CHECK = "@auth.login.check";
export const AUTH_LOGIN_FAIL = "@auth.login.fail";
export const AUTH_LOGOUT_REQUEST = "@auth.logout.request";
export const AUTH_LOGOUT_SUCCESS = "@auth.logout.success";
export const AUTH_ERRORS_CLEAR = "@auth.errors.clear";
export const AUTH_ERRORS_APPEND = "@auth.errors.append";
